import { TemplateRef } from '@angular/core';

export type MessageDialogType = 'alert' | 'confirm';

export enum MessageButtons {
  Close = 'Close',
  YesNo = 'YesNo',
  YesNoCancel = 'YesNoCancel',
}

export interface MessageButtonDef {
  label: string;
  value: any | (() => any);
  closeOnClick?: boolean;
  cssClass?: string | string[];
  isPrimary?: boolean;
  isDestructive?: boolean;
  isFocused?: boolean;
  isEnabled?: boolean | (() => boolean);
}

export interface MessageWithIcon {
  icon: string;
  message: string;
  iconColor?: string;
}

export type MessageContentType = string | TemplateRef<any> | MessageWithIcon;

export interface MessageDialogOptions {
  title: string;
  message: MessageContentType;
  type?: MessageDialogType;
  buttons?: MessageButtons | MessageButtonDef[];
}

export type MessageResult = any;
